import { PjInjectProxy } from './PjInjectProxy';
import { BaseInjectProxyImpl } from '../../framework/BaseInjectProxyImpl';
import { HistoryService } from '../history/service/HistoryService';
import { SharedService } from './controller/PjBaseController';

/**
 * フレームワークで使用するサービスを集約する
 */
export class PjInjectProxyImpl extends BaseInjectProxyImpl implements PjInjectProxy {

    /**
     * @constructor
     * @param {ng.IRootScopeService} $rootScope ルートスコープ
     * @param {ng.IQService} $q 非同期処理
     * @param {angular.ui.IStateService} $state UI Routerのステータス
     * @param {HistoryService} historyService 履歴管理サービス
     */
    /* @ngInject */
    constructor(protected $rootScope: ng.IRootScopeService,
                protected $q: ng.IQService,
                protected $state: angular.ui.IStateService,
              //  protected historyService: HistoryService,
                protected sharedService: SharedService) {
        super($rootScope, $q, $state);
//        sharedService.set('auth', {role: 3, userId: 'test_user_id', companyId: 100, userName: 'ユーザネーム', companyName: 'テスト会社名'});
    }

    /**
     * モーダルを取得
     * @return {HistoryService} 履歴管理サービス
     */
    public getHistoryService(): HistoryService {
        return null;
    }

    /**
     * SharedServiceを取得
     * @return {sharedService} 履歴管理サービス
     */
    public getSharedService(): SharedService {
        return this.sharedService;
    }
}



/** WEBPACK FOOTER **
 ** node_modules/tslint-loader!./src/common/extends_fw/PjInjectProxyImpl.ts
 **/